var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textarea"},[_c('textarea',{staticClass:"form-control",attrs:{"rows":_vm.rows,"placeholder":_vm.placeholder},domProps:{"value":_vm.model},on:{"input":function($event){return _vm.updateSelf($event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }